import { customersApiClient } from './apiClient';

export const notificationService = {
  async getNotifications(filters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });
    const query = params.toString();
    const url = query ? `/notifications?${query}` : '/notifications';

    const result = await customersApiClient.get(url);

    if (!result.success) {
      return {
        success: false,
        data: [],
        pagination: null,
        error: result.error || 'Failed to fetch notifications',
      };
    }

    return {
      success: true,
      data: result.data?.notifications || [],
      pagination: result.data?.pagination || null,
      error: null,
    };
  },

  async getUnreadCount() {
    const result = await customersApiClient.get('/notifications/unread-count');

    if (!result.success) {
      return {
        success: false,
        data: 0,
        error: result.error || 'Failed to fetch unread count',
      };
    }

    return {
      success: true,
      data: result.data?.unread_count ?? 0,
      error: null,
    };
  },

  async markAsRead(id) {
    const result = await customersApiClient.post(`/notifications/${id}/read`, {});

    if (!result.success) {
      return {
        success: false,
        error: result.error || 'Failed to mark notification as read',
      };
    }

    return { success: true, error: null };
  },

  async markAllAsRead() {
    const result = await customersApiClient.post('/notifications/read-all', {});

    if (!result.success) {
      return {
        success: false,
        data: null,
        error: result.error || 'Failed to mark all as read',
      };
    }

    return {
      success: true,
      data: result.data,
      error: null,
    };
  },

  async deleteAll() {
    const result = await customersApiClient.delete('/notifications');

    if (!result.success) {
      return {
        success: false,
        error: result.error || 'Failed to delete notifications',
      };
    }

    return { success: true, error: null };
  },
};

export default notificationService;
